<mat-icon class="dsk-logo" svgIcon="dsk-logo-footer"></mat-icon>
<dskhome-footer-logo-address class="address"></dskhome-footer-logo-address>
<p class="otp-p" i18n>&copy; {{ copyrightYear }} „Банка ДСК“ АД</p>
